import axiosIns from '@/libs/axios'

const ROOT_URL = '/ReportPortal/dashboard'

export default {
  namespaced: true,
  state: {
    cacheInfo: [],
    loadings: {
      counters: false,
      monthlySales: false,
      brandSales: false,
      brandProfitability: false,
      brandProfitabilityTable: false,
      brandStocks: false,
      salePerformance: false,
    },
    dashboardData: {
      counters: {
        ytdSales: 0,
        mtdSales: 0,
        collectionAvg: 0,
        saleValueDateAVG: {
          type: 'ytd',
          ytd: 0,
          mtd: 0,
        },
        interviewSaleRate: 0,
        interviewSaleRate2: {
          type: 'ytd',
          ytd: 0,
          mtd: 0,
        },
      },
      monthlySales: {
        series: [],
        categories: [],
      },
      brandSales: {
        series: [],
        labels: [],
        colors: [],
      },
      brandProfitability: {
        is_ytd: false,
        mtd: {
          date_range: '',
          series: [],
          categories: [],
          colors: [],
        },
        ytd: {
          date_range: '',
          series: [],
          categories: [],
          colors: [],
        },
      },
      brandProfitabilityTable: [],
      brandStocks: {
        series: [],
        categories: [],
        colors: [],
        value_date: [],
      },
      salePerformance: {
        brands: [],
        grandTotals: {
          ytdSales: 0,
          ytdThisYear: 0,
          ytdLastYear: 0,
          lastYtdSales: 0,
          yoyRate: 0,
          mtdSales: 0,
          lastYearMtdSales: 0,
          momRate: 0,
          goals: 0,
          goalsRate: 0,
          swaps: 0,
          swapsRate: 0,
          connections: 0,
          stocks: 0,
        },
      },
    },
  },
  getters: {
    cacheInfo(state) {
      return state.cacheInfo
    },
    loadings(state) {
      return state.loadings
    },
    dashboardData(state) {
      return state.dashboardData
    },
  },
  mutations: {
    SET_BRAND_PROFITABILITY_TYPE(state, data) {
      state.dashboardData.brandProfitability.type = data
    },
    SET_LOADINGS(state, data) {
      if (data.type === 'counters') {
        state.loadings.counters = data.status
      }
      if (data.type === 'monthlySales') {
        state.loadings.monthlySales = data.status
      }
      if (data.type === 'brandSales') {
        state.loadings.brandSales = data.status
      }
      if (data.type === 'brandProfitability') {
        state.loadings.brandProfitability = data.status
      }
      if (data.type === 'brandProfitabilityTable') {
        state.loadings.brandProfitabilityTable = data.status
      }
      if (data.type === 'brandStocks') {
        state.loadings.brandStocks = data.status
      }
      if (data.type === 'salePerformance') {
        state.loadings.salePerformance = data.status
      }
    },

    SET_DASHBOARD_DATA(state, data) {
      if (data.type === 'counters') {
        state.dashboardData.counters = data.data
      }
      if (data.type === 'monthlySales') {
        state.dashboardData.monthlySales = data.data
      }
      if (data.type === 'brandSales') {
        state.dashboardData.brandSales = data.data
      }
      if (data.type === 'brandProfitability') {
        state.dashboardData.brandProfitability = data.data
      }
      if (data.type === 'brandProfitabilityTable') {
        state.dashboardData.brandProfitabilityTable = data.data
      }
      if (data.type === 'brandStocks') {
        state.dashboardData.brandStocks = data.data
      }
      if (data.type === 'salePerformance') {
        state.dashboardData.salePerformance = data.data
      }
    },
    SET_CACHE_INFO(state, data) {
      state.cacheInfo = data
    },
    /* RESET MUTATIONS */
    RESET_DASHBOARD_DATA(state) {
      state.dashboardData = {
        counters: {
          ytdSales: 0,
          mtdSales: 0,
          collectionAvg: 0,
          saleValueDateAVG: {
            type: 'ytd',
            ytd: 0,
            mtd: 0,
          },
          interviewSaleRate: 0,
          interviewSaleRate2: {
            type: 'ytd',
            ytd: 0,
            mtd: 0,
          },
        },
        monthlySales: {
          series: [],
          categories: [],
        },
        brandSales: {
          series: [],
          labels: [],
          colors: [],
        },
        brandProfitability: {
          is_ytd: false,
          mtd: {
            date_range: '',
            series: [],
            categories: [],
            colors: [],
          },
          ytd: {
            date_range: '',
            series: [],
            categories: [],
            colors: [],
          },
        },
        brandProfitabilityTable: [],
        brandStocks: {
          series: [],
          categories: [],
          colors: [],
          value_date: [],
        },
        salePerformance: {
          brands: [],
          grandTotals: {
            ytdSales: 0,
            ytdThisYear: 0,
            ytdLastYear: 0,
            lastYtdSales: 0,
            yoyRate: 0,
            mtdSales: 0,
            lastYearMtdSales: 0,
            momRate: 0,
            goals: 0,
            goalsRate: 0,
            swaps: 0,
            swapsRate: 0,
            connections: 0,
            stocks: 0,
          },
        },
      }
    },
  },
  actions: {
    getData({ commit }, params) {
      commit('SET_LOADINGS', { type: params.type, status: true })
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/salesLive?type=${params.type}`, data)
        .then(response => {
          commit('SET_DASHBOARD_DATA', {
            type: params.type,
            data: response.data.data,
          })
          commit('SET_CACHE_INFO', response.data.cacheInfo)
          commit('SET_LOADINGS', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
    refreshData({ commit }, params) {
      commit('SET_LOADINGS', { type: params.type, status: true })
      const data = JSON.stringify(params)
      axiosIns
        .post(`${ROOT_URL}/salesLive?type=${params.type}&noCache=true`, data)
        .then(response => {
          commit('SET_DASHBOARD_DATA', {
            type: params.type,
            data: response.data.data,
          })
          commit('SET_CACHE_INFO', response.data.cacheInfo)
          commit('SET_LOADINGS', { type: params.type, status: false })
        })
        .catch(error => console.error(error))
    },
  },
}
